import axios, { AxiosPromise } from "axios";

import { ApiResponse } from "../models/app-configuration";
import { default as JSONPath } from "fast-json-patch";
import { DataHelper } from "../utils/data-helper";

export class GenericServices {
  /**
   *
   */
  constructor() {}
  protected executeSelectingNotEncode<TValue, TResult>(
    params?: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .get(path, { params })
      .then(response => response.data)
      .catch(error => error);
  }

  protected getBlobFile<TResult>(path?: string, params?: any): AxiosPromise<TResult> {
    return axios({
      url: path, //your url
      method: 'GET',
      responseType: 'blob', // important
      params: params
    }).then((response) => Promise.resolve(response.data))
    .catch(err => Promise.reject(err))
}

  protected executeSelecting<TValue, TResult>(
    params?: TValue,
    path?: string,
    encodeURI: boolean = true
  ): AxiosPromise<TResult> {
    // var uri = encodeURI ? encodeURIComponent(path) : path;
    return axios
      .get(path, { params })
      .then(response => response.data)
      .catch(error => error);
  }
   
  protected executeSelectingPost<TValue, TResult>(
    value: TValue,
    path?: string,
    cancelTokenSource?: any
  ): AxiosPromise<TResult> {
    return axios
      .post(path, value, {
        cancelToken: cancelTokenSource && cancelTokenSource.token
      })
      .then(response => response.data)
      .catch(error => () => {
        console.log(error);
      });
  }
  protected executeSelectingPostWithParam<TValue, TParam, TResult>(
    value: TValue,
    param: TParam,
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .post(path, value, param)
      .then(response => response.data)
      .catch(error => () => {
        console.log(error);
      });
  }

  protected executeCreating<TValue, TResult>(
    value: TValue,
    path?: string,
    config?: any
  ): Promise<TResult> {
    return axios
      .post(path, value, config)
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeCreatingWithParam<TValue, TParam, TResult>(
    value: TValue,
    params: TParam,
    path?: string
  ): Promise<TResult> {
    return axios
      .post(path, value, { params: params })
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeCreatingAsync<TValue, TResult>(
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .post(path, value)
      .then(response => response.data)
      .catch(error => error);
  }

  protected executeUpdating<TValue, TResult>(
    id: number,
    originVariable: TValue,
    value: TValue,
    path?: string,
    config : any = {}
  ): AxiosPromise<TResult> {
    const v = this.detectInfoObject(value).next().value;
    const cv = this.detectInfoObject(originVariable).next().value;
    return this.generatePatch(cv, v)
      .then(json => {
        return axios
          .patch(path + "/" + id, json,config)
          .then(response => response.data)
          .catch(error => error);
      })
      .catch(error => error);
  }
  protected executeUpdatingCompare<TValue, TResult>(
    originVariable: TValue,
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return this.generatePatch(originVariable, value)
      .then(json => {
        return axios
          .patch(path, json)
          .then(response => response.data)
          .catch(error => error);
      })
      .catch(error => error);
  }

  protected executePatch<TValue, TResult>(
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .patch(path, value)
      .then(response => response)
      .catch(error => error);
  }

  protected executeUpdatingAsync<TOriginalValue, TValue, TResult>(
    originVariable: TOriginalValue,
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .post(path, value)
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeDeleting<TResult>(path?: string): AxiosPromise<TResult> {
    return axios
      .delete(path)
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeDeletingWith<TResult>(
    value,
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .delete(path, { data: value })
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeDeletingMulti<TResult>(
    ids: number[],
    path?: string
  ): AxiosPromise<TResult> {
    return axios
      .delete(path + "/" + ids.join(","))
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeDleteAsync<TOriginalValue, TValue, TResult>(
    originVariable: TOriginalValue,
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    throw new Error("Method not implemented.");
  }
  protected executeSelectBy<TValue, TResult>(
    value: TValue,
    path: string
  ): Promise<TResult> {
    Object.getOwnPropertyNames(value).forEach(
      key => (path = path.replace(`:${key.toLowerCase()}`, value[key]))
    );
    return axios
      .get(path)
      .then(response => response.data)
      .catch(error => error);
  }
  protected executeSelectByAsync<TValue, TResult>(
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    throw new Error("Method not implemented.");
  }
  private *detectInfoObject<T>(object: T) {
    const newObj = DataHelper.deepClone<T>(object);
    Object.keys(newObj).forEach((key, index) => {
      if (key.lastIndexOf("Info") > -1) {
        delete newObj[key];
      } else if (Array.isArray(newObj[key])) {
        newObj[key] = newObj[key].map(
          item => this.detectInfoObject(item).next().value
        );
      }
    });
    yield newObj;
  }
    private generatePatch<TEntity>(origin: TEntity, entity: TEntity) {
      let comparison = JSONPath.compare(origin, entity);
      if (comparison.length === 1 && comparison[0].path === '/CheckingConfictData') {
          return Promise.reject(<ApiResponse>{
              isSuccess: false,
              errorCode: -1000,
              message: "NOTHING_CHANGED"
          });
      }
    return comparison.length > 0
      ? Promise.resolve(comparison)
      : Promise.reject(<ApiResponse>{
          isSuccess: false,
          errorCode: -1000,
          message: "NOTHING_CHANGED"
        });
  }


  protected executePut<TValue, TResult>(
    params: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return axios.put(path, params)
    .then(response => response.data)
    .catch(error => error);
  }

  protected executePost<TValue, TResult>(
    params: TValue,
    path?: string,
    config?: any
  ): AxiosPromise<TResult> {
    return axios.post(path, params, config)
    .then(response => response.data)
    .catch(error => error);
  }
}

/**
 * SERVICE WRAPPER:
 * THIS IS CLASS TO WRAPPER REPONSE FROM SERVICE API
 * HANDLE RESPONSE IS SUCCESS OR ERROR
 * HANDLE EXCEPTION
 */
export class ServicesWrapper extends GenericServices {
  /**
   * METHOD: GET
   * GET DATA FROM SERVICE API
   * @param params
   * @param path
   * @param encodeURI
   */
  protected executeSelecting<TValue, TResult>(
    params?: TValue,
    path?: string,
    encodeURI: boolean = true
  ): AxiosPromise<TResult> {
    return super
      .executeSelecting(params, path, encodeURI)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          return Promise.resolve(response.data);
        } else return Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      });
  }

  /**
   * METHOD: POST
   * GET DATA FROM SERVICE API BASE ON POST DATA
   * @param params
   * @param path
   * @param encodeURI
   */
  protected executeSelectingPost<TValue, TResult>(
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return super
      .executeSelectingPost(value, path)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          return Promise.resolve(response.data);
        } else return Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      });
  }

  /**
   * METHOD: DELETE
   * DELETE DATA BASE ON REQUEST URL
   * @param path
   */
  protected executeDeleting<TResult>(path?: string): AxiosPromise<TResult> {
    return super
      .executeDeleting(path)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          return Promise.resolve(response.data);
        } else return Promise.reject(response.message);
      })
      .catch(ex => {
        return Promise.reject(ex);
      });
  }

  
}
